<div class="container-fluid bg-white vh-100 p-0">
    <ClientLogo v-if="this.$route.name != 'behalf_application'" />
    <BreadCrumb label="Proof Of Income Manual" />
  
    <div class="d-flex flex-column align-items-center  min-vh-50">
      <div class="col-11 col-sm-10 col-md-8 col-lg-6 col-xl-5 p-3">
        <div class="d-flex align-items-center">
          <span><i class="text-muted bi bi-question-circle me-2"></i></span>
          <span class="text-muted text-xs">Proof of income is required when applying for finance to assess your ability to repay the
            loan and confirm your financial stability, ensuring responsible lending decisions.
            </span> 
        </div>
        <div class="form-group mt-3">
          <label for="id_number" class="fw-bold text-xs text-start d-block">ID Number <span class="text-danger">*</span></label>
          <input
            v-model="id_number"
            type="text"
            class="form-control rounded-small shadow-sm w-100"
            id="id_number"
            placeholder="Enter an ID Number"
            @input="handle_input"
            maxlength="13"
            required
            :disabled="is_field_disabled.id_number"
          />
          <small v-if="error_messages.id_number" class="form-text text-danger">
            {{ error_messages.id_number }}
          </small>

          <label for="account_number" class="fw-bold text-xs text-start d-block mt-3">Bank Account Number <span class="text-danger">*</span></label>
          <input
            v-model="account_number"
            type="text"
            class="form-control rounded-small shadow-sm w-100"
            id="account_number"
            placeholder="e.g., 13XXXXX78"
            required
          />
          <small v-if="error_messages.account_number" class="form-text text-danger">
            {{ error_messages.account_number }}
          </small>

          <label class="fw-bold text-xs text-start d-block mt-3">Select Bank<span class="text-danger">*</span></label>
          <select v-model='bank_name' class="form-select rounded-small text-xs" required>
            <option value="" selected disabled hidden>Select Your Bank</option>
            <option value="absa">Absa</option>
            <option value="capitec">Capitec</option>
            <option value="fnb">Fnb</option>
            <option value="investec">Investec</option>
            <option value="nedbank">Nedbank</option>
            <option value="standard_bank">Standard Bank</option>
            <option value="tyme_bank">Tyme</option>
          </select>
          <small v-if="error_messages.bank_name" class="form-text text-danger">
            {{ error_messages.bank_name }}
          </small>

          <label for="bank_statement" class="fw-bold text-xs text-start d-block mt-3">Upload Document (Bank Statement) <span class="text-danger">*</span></label>
          <input
          type="file"
          class="form-control rounded-small shadow-sm w-100"
          id="bank_statement"
          accept="application/pdf"
          @change="on_file_change($event)"
          ref="bank_statement"
          required
          />
          <small v-if="error_messages.bank_statement" class="form-text text-danger">
            {{ error_messages.bank_statement }}
          </small>
        </div>
      </div>

      <div class="text-center mb-3 mt-4">
        <button
          class="btn btn-sm bg-green text-dark rounded-small fw-bold secondary-text-dark shadow-sm"
          @click="manual_proof_of_income">
          Continue
        </button>
      </div>
    </div>
  </div>
  